export enum ProductCollectionType {
  ResiBtl = 'ResiBtl',
  Bridging = 'Bridging',
}
